import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import InfoSelectors from '../selectors/InfoSelectors';
import RegistrationSlice from '../common/slices/RegistrationSlice';
import AuthSelectors from '../selectors/AuthSelectors';
import { AuthService } from '../services/AuthService';
import resolveCompanyLogoUrl from '../helpers/resolveCompanyLogoUrl';
import resolveCompanyName from '../helpers/resolveCompanyName';
import resolveDocumentTitle, {
    DEFAULT_DOCUMENT_TITLE,
} from '../helpers/resolveDocumentTitle';
import resolveFaviconHref from '../helpers/resolveFaviconHref';

const DEFAULT_FAVICON_HREF = '/favicon-196.png';

export default function useWhitelabelBranding() {
    const infoData = useSelector(InfoSelectors.getData);
    const { data: registration } = useSelector(RegistrationSlice.state.getAll);
    const authToken = useSelector(AuthSelectors.getAuthToken);

    const isWhitelabel = infoData?.customization?.whitelabel === true;
    const companyName = resolveCompanyName(
        infoData?.companyName,
        AuthService.getCompanyName(authToken),
    );
    const companyLogoUrl = resolveCompanyLogoUrl(
        registration?.companyLogo,
        infoData?.logo,
    );

    useEffect(() => {
        document.title = resolveDocumentTitle(isWhitelabel, companyName);

        return () => {
            document.title = DEFAULT_DOCUMENT_TITLE;
        };
    }, [isWhitelabel, companyName]);

    useEffect(() => {
        const faviconLink = document.querySelector(
            'link[rel="icon"]',
        ) as HTMLLinkElement | null;

        if (!faviconLink) {
            return;
        }

        const originalHref = faviconLink.href;
        faviconLink.href = resolveFaviconHref(
            isWhitelabel,
            companyLogoUrl,
            DEFAULT_FAVICON_HREF,
        );

        return () => {
            faviconLink.href = originalHref;
        };
    }, [isWhitelabel, companyLogoUrl]);
}
